import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApiBackendClient } from '../../helpers/api_backend_helper';
import { GET_SG_MAERUT } from '../../helpers/url_helper';

const useCreateCliente = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);
    const departamento = useSelector((state) => state.Context.departamento);
    const userInfo = useSelector((state) => state.UserInfo.userInfo);

    const apiBackendClient = new ApiBackendClient();

    const createCliente = async (datosCliente) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Datos a guardar:', datosCliente);
            const queryParams = `?tenantId=${tenantId}&empresa=${empresa}&departamento=${departamento}`;
            const response = await apiBackendClient.create(`${GET_SG_MAERUT}${queryParams}`, {
                sg_maerutData: datosCliente,
                usuario: userInfo?.name
            });
            console.log('Response from API:', response);
            if (response.CLACLI) {
                const result = response;
                console.log('Cliente creado con éxito:', result);
                return { success: true, data: result };
            } else {
                throw new Error(response.message || 'Error al guardar el cliente');
            }
        } catch (err) {
            const errorMessage = `Failed to create cliente: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { createCliente, loading, error };
};

export default useCreateCliente;